import React from 'react';
import {Alert, AlertType, Button} from '@cuatroochenta/co-admin-react-library';
import {
    useCustomButtonListSummaryController
} from '../useCustomButtonListSummaryController';
import {BulletinHoursListIdsRequest} from '../../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';

interface Props {
    filtersRef: React.MutableRefObject<BulletinHoursListIdsRequest>;
}

export const CustomButtonListSummary = ({filtersRef}: Props) => {
    const controller = useCustomButtonListSummaryController();

    return (
        <>
            <Alert show={!!controller.error} message={controller.error} type={AlertType.DANGER} />
            <Button
                onClick={() => controller.handleExportExcel(filtersRef.current)}
                content={'Exportar Excel'}
            />
        </>
    );
};
